import img1 from '../../../media/about/start/IMG_5273.jpg';
import img2 from '../../../media/about/start/IMG_6538.JPG';
import img3 from '../../../media/about/start/razer.png';

const startStory = {
    id: "started",
    title: "From the Beginning",
    heroImage: img3,
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    description: `For as long as I could remember, I've always been interested in engineering and technology. From building portable chargers out of cigarette lighters and altoid cans, to building my own computer. I always wanted to dive into the computer realm as I got older. When I got to college, I dived headfirst into coding and never looked back.`,
    gallery: [
        { type: 'image', src: img2, alt: 'Altoid can charger' },
        { type: 'image', src: img1, alt: 'Early computer setup' }
    ]
};

export default startStory;
